export default __webpack_public_path__ + "5d4ad7f6cc8353ae335fcdef503936ae.svg";